import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect as soon as user session is established
    if (user) {
      navigate('/dashboard', { replace: true });
      return;
    }

    // Safety net: if no auth after 10 seconds, treat as failure
    const timeout = setTimeout(() => {
      if (!user) {
        navigate('/login?error=auth_failed', { replace: true });
      }
    }, 10000);

    return () => clearTimeout(timeout);
  }, [user, navigate]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="h6" color="text.secondary">
          Completing sign in...
        </Typography>
      </Box>
    </Container>
  );
};

export default AuthCallback;
